import { DriverDTO } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';

import { getSystemDriverNotes } from './getSystemDriverNotes';

export const selectDriverNotes = (driver: DriverDTO): string | undefined => {
    const type = driver.type;
    switch (type) {
        case 'User':
            return driver.data.notes ?? undefined;
        case 'System':
            return getSystemDriverNotes(driver.data);
        default:
            assertUnreachable(type);
    }
};
